


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDFlmsf0OjuAuX8CXV_jy_yw1Lr0maSPV4",
  authDomain: "eric-ganesh-opticals.firebaseapp.com",
  projectId: "eric-ganesh-opticals",
  storageBucket: "eric-ganesh-opticals.firebasestorage.app",
  messagingSenderId: "1040635802764",
  appId: "1:1040635802764:web:351e5d35cf0c744d5e37a9"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export